import { UploadFiles } from "./UploadFiles";

export class UploadFilesRtn {
    success: string;
    message: string;
    data: UploadFiles;
}